import { configureStore } from '@reduxjs/toolkit';
import reportReducer from './ReportState';
import TradeInReducer from './TradeInState';
import LeadCreationReducer from './LeadCreationState';
import CommonModuleReducer from './CommonModuleState';
import CreditScoreReducer from './CreditScoreState';
import DigitalRetailingReducer from './DigitalRetailingState';
import AuthReducer from './Auth'; // Ensure this path is correct

import thunk from 'redux-thunk';

export const store = configureStore({
  reducer: {
    reportStore: reportReducer,
    tradeInStore: TradeInReducer,
    leadCreationStore: LeadCreationReducer,
    commonModuleStore: CommonModuleReducer,
    creditScoreStore: CreditScoreReducer,
    auth: AuthReducer,
    digitalRetailingStore: DigitalRetailingReducer,
  },
  // middleware: [thunk],
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
